<template>
    <el-dialog
        :visible="visible"
        :title="isEditing ? 'Edit free text' : 'Add free text to Knowledge Base'"
        width="700px"
        :close-on-click-modal="false"
        @close="handleClose"
    >
        <div class="mb-3">
            <p>
                <small>
                    <i>Enter free text content without formatting. Maximum length: 5,000 characters. Title maximum: 255 characters.</i>
                </small>
            </p>
        </div>
        <el-form :model="form">
            <el-form-item required class="no-border">
                <el-input
                    v-model="form.title"
                    placeholder="Enter a title for this text entry"
                    maxlength="255"
                    show-word-limit
                />
            </el-form-item>
            <el-form-item required class="no-border">
                <el-input
                    v-model="form.text"
                    type="textarea"
                    :rows="10"
                    placeholder="Enter your text content here"
                    maxlength="5000"
                    show-word-limit
                />
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">Cancel</el-button>
            <el-button type="primary" :loading="loading" @click="handleSubmit">{{ isEditing ? 'Save changes' : 'Add free text' }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'AddTextModal',

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        bot: {
            type: Object,
            required: true
        },
        content: {
            type: Object,
            default: null
        },
        isEditing: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            form: {
                title: '',
                text: ''
            },
            contentId: null
        }
    },

    watch: {
        visible(newVal) {
            if (newVal && this.isEditing && this.content) {
                this.$nextTick(() => {
                    this.loadContentData()
                })
            } else if (!newVal) {
                this.resetForm()
            }
        },
        content: {
            handler(newVal) {
                if (this.visible && this.isEditing && newVal) {
                    this.$nextTick(() => {
                        this.loadContentData()
                    })
                }
            },
            immediate: true
        }
    },

    methods: {
        handleClose() {
            this.$emit('close')
        },

        resetForm() {
            this.form = {
                title: '',
                text: ''
            }
            this.contentId = null
        },

        loadContentData() {
            if (this.content) {
                // For TEXT type, use the name field which contains the title
                // The transformer returns title in the 'name' field
                this.form.title = this.content.name || this.content.title || ''
                this.form.text = this.content.content || ''
                this.contentId = this.content.id || null
            }
        },

        handleSubmit() {
            if (!this.form.title.trim() || !this.form.text.trim()) {
                this.$message.warning('Please fill in both title and text fields')
                return
            }

            this.loading = true

            const payload = {
                title: this.form.title,
                text: this.form.text
            }

            if (this.isEditing && this.contentId) {
                payload.content_id = this.contentId
            }

            axios.post('/api/v1/aloai/bot/' + this.bot.id + '/add-text', payload)
            .then((res) => {
                this.$message.success(this.isEditing ? 'Text updated successfully' : 'Text added successfully')
                this.$emit('success')
                // Close modal after success
                this.$nextTick(() => {
                    this.handleClose()
                })
            })
            .catch((err) => {
                const message = err.response?.data?.message || (this.isEditing ? 'Failed to update text' : 'Failed to add text')
                this.$message.error(message)
                this.$emit('failed')
            })
            .finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
